// extracted by mini-css-extract-plugin
module.exports = {"article":"_0iaGS5","line-in":"N1BceQ","icon":"Td93dj"};